import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { Curious } from '@curi/react';
import __isEmpty from 'lodash/isEmpty';
import __map from 'lodash/map';
import { generalFAQs, billingFAQs, giftingFAQs } from './faqs.js';

import './FAQWrapper.css';
import { gtmPageviewEvent } from '../../services/google-tag-manager';
import PageHeader from '../../components/global/PageHeader';
import Collapsible from '../../components/global/Collapsible';

const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;

class FAQ extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openFAQ: false,
        }
    }

    componentDidMount() {
        gtmPageviewEvent({
            pageName: 'codespark.com: FAQ',
            componentProps: this.props,
        });

        if (!__isEmpty(this.props.response.location.hash)) {
            let questionId = this.props.response.location.hash;
            setTimeout(() => {
                this.toggleCollapsible(questionId);
            }, 300);
        }
    }

    toggleCollapsible(anchor) {
        if (this.state.openFAQ === anchor) {
            this.setState({ openFAQ: false });
        } else {
            this.setState({ openFAQ: anchor });
        }
    }

    render() {
        return (
            <div className="app">
                <Helmet>
                    <title>codeSpark Support</title>
                    <meta name="description" content="We're here to help! Our FAQ page has answers to billing and acount questions, technical support, and gifting. You can also reach out to us directly at support@codespark.com." />
                    <meta name="keywords" content="Kids coding languages, coding for kids, kids apps, kids games, learn to code, STEM, Reading, Math, Elementary school" />
                    <meta property="og:title" content="Coding Game for Kids - Try it Free!" />
                    <meta property="og:description" content="Try the #1 learn-to-code app for kids ages 3-10. Used by over 20 million kids worldwide, kids learn coding basics with puzzles and build skills to make their own games." />
                    <meta name="twitter:card" content="app" />
                    <meta name="twitter:site" content="@codesparkapp" />
                    <meta name="twitter:description" content="Try the #1 learn-to-code app for kids 4+. Used by over 20 Million kids, codeSpark teaches coding basics through creative play and game creation. Coding improves STEM, reading, and math skills." />
                    <meta name="twitter:app:country" content="US" />
                    <meta name="twitter:app:id:iphone" content="923441570" />
                    <meta name="twitter:app:id:ipad" content="923441570" />
                    <meta name="twitter:app:id:googleplay" content="org.codespark.thefoos" />
                </Helmet>
                <div className="faq-page page">
                    <PageHeader text="Frequently Asked Questions" />
                    <div className="grid-x grid-padding-x align-center faq-intro-container">
                        <div className="small-12 medium-6 cell intro-details">
                            <p>
                                If you do not see an answer to your question below, check out
                                our <a href="https://codespark.uservoice.com/knowledgebase" target="_blank" rel="noopener noreferrer">Knowledge Base</a> for
                                more help.&nbsp;
                                <a href="mailto:support@codespark.com">Support</a> hours are:<br />
                                Monday thru Friday, 9am - 6pm PST<br />
                                Saturday thru Sunday, 9am - 12pm PST.
                            </p>
                        </div>
                        <div className="medium-2 cell show-for-medium">
                            <img alt="" src={`${imgURL}/wp-transfer/foo_einstein.png`} aria-hidden="true" />
                        </div>
                    </div>
                    <div className="grid-x grid-padding-x align-center faq-billing-container">
                        <div className="small-12 medium-9 cell billing-details">
                            <h2 className="section-title">Billing/Technical Questions</h2>
                            <div className="accordion">
                            {
                                __map(billingFAQs, (block, i) => {
                                    return (
                                        <Collapsible key={ i }
                                            id={ block.anchor }
                                            triggerHTML={ block.question }
                                            transitionTime={ 250 }
                                            easing="ease"
                                            open={ this.state.openFAQ === block.anchor }
                                            handleTriggerClick={ () => this.toggleCollapsible(block.anchor) }
                                        >
                                            <div className="faq-answer">
                                                <div dangerouslySetInnerHTML={{ __html: block.answer }}></div>
                                            </div>
                                        </Collapsible>
                                    )
                                })
                            }
                            </div>
                        </div>
                    </div>
                    <div className="grid-x grid-padding-x align-center faq-general-container">
                        <div className="small-12 medium-9 cell general-details">
                            <h2 className="section-title">General/Education Questions</h2>
                            <div className="accordion">
                            {
                                __map(generalFAQs, (block, i) => {
                                    return (
                                        <Collapsible key={ i }
                                            id={ block.anchor }
                                            triggerHTML={ block.question }
                                            transitionTime={ 250 }
                                            easing="ease"
                                            open={ this.state.openFAQ === block.anchor }
                                            handleTriggerClick={ () => this.toggleCollapsible(block.anchor) }
                                        >
                                            <div className="faq-answer">
                                                <div dangerouslySetInnerHTML={{ __html: block.answer }}></div>
                                            </div>
                                        </Collapsible>
                                    )
                                })
                            }
                            </div>
                        </div>
                    </div>
                    <div className="grid-x grid-padding-x align-center faq-gifting-container">
                        <div className="small-12 medium-9 cell gifting-details">
                            <h2 className="section-title">Gifting Questions</h2>
                            <div className="accordion">
                            {
                                __map(giftingFAQs, (block, i) => {
                                    return (
                                        <Collapsible key={ i }
                                            id={ block.anchor }
                                            triggerHTML={ block.question }
                                            transitionTime={ 250 }
                                            easing="ease"
                                            open={ this.state.openFAQ === block.anchor }
                                            handleTriggerClick={ () => this.toggleCollapsible(block.anchor) }
                                        >
                                            <div className="faq-answer">
                                                <div dangerouslySetInnerHTML={{ __html: block.answer }}></div>
                                            </div>
                                        </Collapsible>
                                    )
                                })
                            }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

FAQ.contextTypes = {
    mixpanel: PropTypes.object
};

export default props => (
    <Curious>
        {({ router, response, navigation }) => {
            return <FAQ router={ router } response={ response } { ...props } />;
        }}
    </Curious>
);



// WEBPACK FOOTER //
// ./src/containers/FAQ/index.js